import axios from "axios";

export const emittedRetentionApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-emitted-retention`,
  headers: { "Content-Type": "application/json" },
});
